module.exports = __webpack_public_path__ + "img/layer2.8bf5f455.png";